import { Tabs as TabsUI } from "@/src/components/Tabs";

export function Tabs(props: any) {
  return (
    <TabsUI
      {...props}
      tabs={props.steps?.map((tab: any) => ({ label: tab }))}
    />
  );
}
